module.exports = __webpack_public_path__ + "img/semaglutide_5.0985a55f.jpg";